<template>

    <b-card no-body class="page-card statistics-widget">

        <b-card-header class="mx-3 px-0">
            <i class="fa fa-align-justify"></i> {{ trans.title }}
        </b-card-header>

        <div class="loading-box" v-if="loading">
            <div class="loading-inner"><i class="fa fa-spin fa-circle-notch text-secondary"></i></div>
        </div>

        <b-card-body class="inline-scroll" v-if="!loading" v-cloak>

            <table class="table mb-4">
                <thead>
                    <tr>
                        <th colspan="2">{{ trans.table_employees.title }}</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, key) in data.contract_types" :key="key">
                        <td>{{ item.title }}:</td>
                        <td class="text-right">{{ item.count }}</td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <th>{{ trans.table_employees.total }}</th>
                        <th class="text-right">{{ getTotalCount(data.contract_types) }}</th>
                    </tr>
                </tfoot>
            </table>


            <table class="table mb-4">
                <thead>
                    <tr>
                        <th colspan="2">{{ trans.table_work_types.title }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, key) in data.work_types" :key="key">
                        <td>{{ translateWorkDayValue(item.title) }}:</td>
                        <td class="text-right">{{ Number.parseFloat(item.count).toFixed(2) }} h.</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th>{{ trans.table_work_types.total }}</th>
                        <th class="text-right">{{ getTotalCount(data.work_types).toFixed(2) }} h.</th>
                    </tr>
                </tfoot>
            </table>

            
            <table class="table">
                <thead>
                    <tr>
                        <th colspan="2">{{ trans.table_other.title }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ trans.table_other.night_hours }}:</td>
                        <td class="text-right">{{ Number.parseFloat(data.other.night).toFixed(2) }} h.</td>
                    </tr>
                    <tr>
                        <td>{{ trans.table_other.holiday }}:</td>
                        <td class="text-right">{{ Number.parseFloat(data.other.offday).toFixed(2) }} h.</td>
                    </tr>
                </tbody>
            </table>

        </b-card-body>

    </b-card>

</template>

<script>
    export default {
        props: {
            'trans': {
                type: Object
            },
            'transWorkDay': {
                type: Object
            },
            'url': {
                type: String
            },
            'selectedDay': {
                type: String
            },
            'filter': {
                type: String
            }
        },

        data() {
            return {
                loading: true,
                data: {
                    'contract_types': [],
                    'work_types': [],
                    'other': {
                        'night': 0,
                        'offday': 0
                    }
                }
            };
        },
        
        created() {
            this.loadData();
        },
        
        methods: {
            loadData() {
                this.loading = true;
                
                let data = {
                    params: {
                        type: this.filter
                    }
                };

                axios.get(this.url, data)
                     .then(response => {
                         
                        this.data = response.data;
                        this.loading = false;

                     })
                     .catch(error => {});
            },
            
            getTotalCount(data) {
                let cnt = 0;
                
                for(var x in data) {
                    cnt += parseFloat(data[x].count);
                }
                
                return cnt;
            },
            
            translateWorkDayValue(type) {
                var shortVal = "";
                var val = "";

                for (const [key, value] of Object.entries(this.transWorkDay) ) {
                    if(type+"_short" == key) shortVal = value;
                    if(type == key) val = value;
                }
                return (shortVal ? shortVal : (val ? val : '?'));
            }

        },

        watch: {
            filter: function(newVal, oldVal) {
                if(newVal != oldVal) {
                    this.loadData()
                }
            }
            
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/admin/js/report/daily-report/widgets/Statistics.vue